export default __webpack_public_path__ + "static/BannerJsonImageAndTextWithAction_ImageLeftLight-d70649b0f0f6a5fbf48b00d97e14ebbc.jpg";